import styledC, { css } from 'styled-components';

import {
  CombinedTheme,
  MenuBackgrounds,
  getMenuDynamicStyles,
} from '@adsk/alloy-react-styles';

export type StyledButtonProps = {
  disabled?: boolean;
  $nested?: boolean;
  $showSelection?: boolean;
  $selected?: boolean;
  $highlighted?: boolean;
  $isKeyboardNavigation?: boolean;
  $isEnterActive?: boolean;
  $tokens?: CombinedTheme['tokens'];
  $overrideBackgrounds?: Partial<MenuBackgrounds>;
};

export const StyledButton = styledC.button<StyledButtonProps>`
    display: inline-flex;
    align-items: center;
    border: none;
    outline: none;
    text-decoration: none;
    position: relative;
    justify-content: start;
    text-align: start;
    width: 100%;
    margin: 0px;

    &:focus-within {
      box-shadow: none;
    }

    ${({
      $tokens,
      $showSelection,
      $selected,
      $highlighted,
      $nested,
      $isKeyboardNavigation,
      $isEnterActive,
      $overrideBackgrounds,
      disabled,
    }) => {
      const { _, idle, selected, backgrounds } =
        $tokens?.component?.menu?.item ?? {};

      const isSelected = $showSelection && $selected;
      const mergedBackgrounds = $overrideBackgrounds
        ? { ...backgrounds, ...$overrideBackgrounds }
        : backgrounds;
      const dynamicBackgrounds = getMenuDynamicStyles({
        backgrounds: mergedBackgrounds,
        disabled,
        isNested: $nested,
        isEnterActive: $isEnterActive,
        isHighlighted: $highlighted,
        isKeyboardNavigation: $isKeyboardNavigation,
        isSelected,
      });

      const stateStyles = (isSelected ? selected : idle) ?? {};
      const style = {
        ..._,
        ...stateStyles,
        ...dynamicBackgrounds,
      };

      return css`
        ${style}
      `;
    }}
  `;
